<template>
  <div
    class="sprite-popup setting-popup"
    v-show="boxData.judgeBox"
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)"
      :style="{'cursor': 'move'}"
    >形状裁剪</div>

    <div class="setting-popup__content">
      <div class="operation-btns">
        <div
          class="operation-btn"
          :class="{disabled: mySprite.action === 'cropping'}"
          @click="cropFree(mySprite.action === 'cropping')"
        >
          <i class="crop"></i>
          <span>自由裁剪</span>
        </div>
        <div
          class="operation-btn"
          :class="{disabled: !mySprite.cropType}"
          @click="uncrop(!mySprite.cropType, mySprite)"
        >
          <i class="uncrop"></i>
          <span>不裁剪</span>
        </div>
      </div>
      <!-- <div class="msg"><span>选择您喜欢的形状进行剪裁</span></div> -->
      <div
        class="list-wrapper __custom"
        v-bar
      >
        <ul class="list">
          <li
            class="item"
            :class="{active: activeIndex === i}"
            v-for="(item, i) in items"
            @click="onSelect(item, i)"
          >
            <img :src="$handleAssetsUrl(item.thumbnailUrl)" alt="">
          </li>
        </ul>
      </div>
      <div class="operation-btns">
        <div
          class="operation-btn confirm"
          @click="onConfirm()"
        >
          <span>确定裁剪</span>
        </div>
        <div
          class="operation-btn"
          @click="onCancel()"
        >
          <span>取消</span>
        </div>
      </div>
    </div>

    <!-- <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import popup from '../mixins/popup'

export default {
  mixins: [popup],
  data () {
    return {
      popupType: 'cropping',
      items: null,
      activeIndex: -1,
      mySprite: {}
    }
  },
  computed: {
    ...mapGetters([
      'TOOL',
      'SelectScenes_Msg',
      'SelectSprites_Msg',
    ]),
    // mySprite () {
    //   return (this.boxData.data || {}).sprite || {};
    // }
  },
  watch: {
    'boxData.judgeBox': async function (val) {
      if (!this.items) {
        this.items = await this.getItems();
      }
      if (val) {
        this.mySprite = (this.boxData.data || {}).sprite || {};
        this.items.some((item, i) => {
          let isMatch = item.url === this.mySprite.cropUrl;
          if (isMatch) {
            this.activeIndex = i;
          }
          return isMatch
        });
      }
    }
  },
  methods: {
    cropFree (disabled) {
      if (disabled) {
        return;
      }
      this.$bus.emit('cropsvglayer', false);
      this.$bus.emit('cropfreelayer');
      this.$bus.emit('FeaturesPop_vue', {
        name: 'cropping',
        type: 1,
      });
    },
    uncrop (disabled) {
      if (disabled) {
        return;
      }
      this.$bus.emit('cropping.uncrop');
    },
    onConfirm () {
      this.$bus.emit('cropping.confirm');
    },
    onCancel () {
      this.$bus.emit('cropping.cancel');
    },
    onSelect (item, index) {
      this.activeIndex = index;
      this.$bus.emit('cropping.select', item.url);
    },
    isFreeCropping () {
      return $('.crop-layer>.backdrop:visible').length;
    },
    isSvgCropping () {
      return $('.crop-svg-layer').length;
    },
    getItems () {
      return this.$http.get('/api/common/material?pIndex=1&sOfPage=24&fPage=9999&type=17&fileType=46&findAll=1')
        .then(res => {
          res.data.data
          return res.data.data;
        })
        .catch(err => [])
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 208px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding-top: 0;
  }
}

.operation-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 64px;
}

.operation-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  height: 32px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #f0f0f8;
  cursor: pointer;
  background-color: #f0f0f8;

  &.confirm {
    background-color: #5778fb;
    color: #fff;
  }
  &:first-child {
    margin-right: 8px;
  }
  & > i {
    width: 16px;
    height: 16px;
    margin-right: 4px;
  }
  & > i.crop {
    background-image: url(../../../static/svg/crop-4.9.3.svg);
    background-repeat: no-repeat;
  }
  & > i.uncrop {
    background-image: url(../../../static/svg/uncrop-4.9.3.svg);
    background-repeat: no-repeat;
  }
}

.msg {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 30px;
  padding-left: 10px;
  font-size: 12px;
  color: #aca8c4;
}

.list-wrapper {
  height: 290px;
}

.list {
  box-sizing: border-box !important;
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-x: auto !important;
  padding-top: 2px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 17px;
}
.item {
  position: relative;
  width: 56px;
  height: 56px;
  background-color: #ffffff;
  border-radius: 4px;
  border: solid 1px #f0f0f8;
  margin-bottom: 10px;
  &:hover, &.active {
    border-color: #5778fb;
    box-shadow: 0px 0px 0px 1px #5778fb;
  }
  &>img {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 0;
    margin: auto;
    width: auto;
    height: auto;
    max-width: 90%;
    max-height: 90%;
  }
}
.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/cropping.vue